var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal_y-axis border-r border-shade-3 bg-shade-0"},_vm._l((_vm.rows),function(row,index){return _c('div',{key:index,staticClass:"cal_y-axis-text",style:(`height:80px;min-height:80px`)},[_c('span',{class:index===0?'pt-1':'',domProps:{"textContent":_vm._s(row)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }